import { render, staticRenderFns } from "./resource-bingli.vue?vue&type=template&id=b6d740c0&scoped=true&"
import script from "./resource-bingli.vue?vue&type=script&lang=ts&"
export * from "./resource-bingli.vue?vue&type=script&lang=ts&"
import style0 from "./resource-bingli.vue?vue&type=style&index=0&id=b6d740c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d740c0",
  null
  
)

export default component.exports